import { render, staticRenderFns } from "./company-custom-field.vue?vue&type=template&id=04831aae"
import script from "./company-custom-field.vue?vue&type=script&lang=js"
export * from "./company-custom-field.vue?vue&type=script&lang=js"
import style0 from "./company-custom-field.vue?vue&type=style&index=0&id=04831aae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports